/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-param-reassign */
// eslint-disable-next-line no-nested-ternary
import { IUrlInformation } from "api/interfaces/get-page-details/common/nested-pagecontent.type";
import { b2bUrl, oeUrl } from "util/url/static-urls";
import {
  FITMENT_TIER_PAGES, TIER_MAKE_MODEL_PAGES, TIER_MAKE_PAGES, TIER_PAGES,
} from "../product/product-constants";

export const DELIVERY_METHODS = {
  PICKUP: "PICKUP",
  SHIPPING: "SHIPMENT",
  DELIVERY: "DELIVERY",
};

export const POSTAL_CODE_REGEX = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;

export function toInt(str) {
  return parseInt(str, 10);
}

export const DEFAULT_FORMAT = ["make", "model", "year"];

export const isTier0Page = (pageType: string) => {
  if ([TIER_PAGES[0], TIER_MAKE_MODEL_PAGES[0], FITMENT_TIER_PAGES[0]].includes(pageType)) {
    return true;
  }
  return false;
};

export const isTier1Page = (pageType: string) => {
  if ([TIER_PAGES[1], TIER_MAKE_PAGES[0], TIER_MAKE_MODEL_PAGES[1], FITMENT_TIER_PAGES[1]].includes(pageType)) {
    return true;
  }
  return false;
};

export const isTier2Page = (pageType) => {
  if ([TIER_PAGES[2], TIER_MAKE_PAGES[1], TIER_MAKE_MODEL_PAGES[2], FITMENT_TIER_PAGES[2]].includes(pageType)) {
    return true;
  }
  return false;
};

export const isTier3Page = (pageType) => {
  if ([TIER_PAGES[3], TIER_MAKE_PAGES[2], TIER_MAKE_MODEL_PAGES[3]].includes(pageType)) {
    return true;
  }
  return false;
};

export const getCurrentCategory = (urlInformation: IUrlInformation, query) => {
  const { tier0 } = urlInformation;
  const tier1 = urlInformation.tier1 || query.tier1;
  const tier2 = urlInformation.tier2 || query.tier2;
  const tier3 = urlInformation.tier3 || query.tier3;
  return tier3 || tier2 || tier1 || tier0 || "";
};

export const getCurrentCategoryPageType = (urlInformation: IUrlInformation, query) => {
  const tier1 = urlInformation.tier1 || query.tier1;
  const tier2 = urlInformation.tier2 || query.tier2;
  const tier3 = urlInformation.tier3 || query.tier3;
  if (tier3) return "tier3";
  if (tier2) return "tier2";
  if (tier1) return "tier1";
  return "tier0";
};

// export const distanceBetweenElements = (elementOne: ReactNode, elementTwo: ReactNode,
//   fromWhichSide: "left" | "right" | "top" | "down" = "right", offset = 0): boolean => {
//   const oppositeMapping = {
//     left: "right",
//     right: "left",
//     top: "down",
//     down: "top",
//   };

//   const defaultOffset = 10; // for extra padding

//   // element one should be the far one.
//   if (elementOne && elementTwo) {
//     const offset1 = elementOne.getBoundingClientRect();
//     const offset2 = elementTwo.getBoundingClientRect();
//     const d1 = offset1[fromWhichSide];
//     // Calculate distance from opposite side as element2 whole width needs to be included
//     // because that much space is already available to fit the dropdown
//     const oppositeSide = oppositeMapping[fromWhichSide];
//     const d2 = offset2[oppositeSide];
//     return d1 - d2 > offset2.width + offset + defaultOffset;
//   }
//   return false;
// };

export const isInViewport = (el: Element | null, offset: number) => {
  const rect = el?.getBoundingClientRect();
  if (!rect) {
    return null;
  }

  return (
    Number(rect.top.toFixed()) + rect.height - 70 >= offset
    && Number(rect.top.toFixed()) < window.innerHeight // Section top is visible or crossed once in view port
    && Number(rect.left.toFixed()) >= 0
    && Number(rect.right.toFixed()) <= (window.innerWidth || document.documentElement.clientWidth) // sometimes exact width of rect goes in decimal.

  );
};

// Returns true if it's a tier0 category page
export function isActualTier0(urlInformation: IUrlInformation) {
  const {
    tier0, tier1, tier2, tier3,
  } = urlInformation;
  return tier0 && !tier1 && !tier2 && !tier3;
}

// Returns true if it's a tier1 category page
export function isActualTier1(urlInformation: IUrlInformation) {
  const {
    tier0, tier1, tier2, tier3,
  } = urlInformation;
  return tier0 && tier1 && !tier2 && !tier3;
}

export function isBusinessHP(pathname: string) {
  return pathname === b2bUrl;
}

export function isOEHP(pathname: string) {
  return pathname.includes(oeUrl);
}

export function isSafari() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("safari") && !ua.includes("chrome");
}

export function isChrome() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("chrome") && !!window.chrome;
}

export function camelCaseToTitleCase(str: string) {
  return str
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add a space before uppercase letters preceded by lowercase letters
    .replace(/^./, (char) => char.toUpperCase()); // Capitalize the first letter
}

export const reviewsCount = 18508;
